module.exports = __webpack_public_path__ + "img/imgTooltipEn.e37effb3.jpg";